import { buildScopedI18n } from '../../utils/buildScopedI18n';
import clientsEsCL from './locales/es-CL.json';
import clientsEnUS from './locales/en-US.json';
import clientsPtBR from './locales/pt-BR.json';

export const clientsI18n = buildScopedI18n({
  esCL: clientsEsCL,
  enUS: clientsEnUS,
  ptBR: clientsPtBR,
});
